import React, { useEffect, useRef } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import {
  LenderMappingsFormValues,
  LenderFieldMapWithErrors,
} from 'modules/vendorOpportunity/dynamicLenderSubmissionMappings/types';
import { DateField } from 'components/form';
import { LenderFieldMap } from '@trnsact/trnsact-shared-types';
import { DateFormats } from 'constants/common';
import { sanitizeFormKey } from 'modules/vendorOpportunity/dynamicLenderSubmissionMappings/lib';

interface Props {
  field: LenderFieldMapWithErrors;
  onValueChange: (lenderProperty: string, newValue: any) => void;
}

export const DateMappingField = ({ field, onValueChange }: Props) => {
  const { control } = useFormContext<LenderMappingsFormValues>();

  const currentValue = useWatch({
    control,
    name: `mappingsByLenderProperty.${sanitizeFormKey(field.lenderProperty!)}.mappedValue`,
  });

  const prevValueRef = useRef(currentValue);

  useEffect(() => {
    if (prevValueRef.current !== currentValue && field.lenderProperty) {
      prevValueRef.current = currentValue;
      onValueChange(field.lenderProperty, currentValue);
    }
  }, [currentValue, field.lenderProperty, onValueChange]);

  const hasError = !!field.details?.errors?.length;

  return (
    <DateField
      label={field.details?.displayName!}
      control={control}
      name={`mappingsByLenderProperty.${sanitizeFormKey(field.lenderProperty!)}.mappedValue`}
      format={DateFormats.Short}
      slotProps={{
        textField: {
          variant: 'outlined',
          size: 'small',
          required: field.details?.required === 'REQUIRED',
          error: hasError,
          helperText: hasError ? field.details?.errors?.map(e => e.message).join(', ') : '',
        },
      }}
    />
  );
};
